import { render, staticRenderFns } from "./CompanyJixiaoReport.vue?vue&type=template&id=2d8bb2cd&scoped=true"
import script from "./CompanyJixiaoReport.vue?vue&type=script&lang=js"
export * from "./CompanyJixiaoReport.vue?vue&type=script&lang=js"
import style0 from "./CompanyJixiaoReport.vue?vue&type=style&index=0&id=2d8bb2cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8bb2cd",
  null
  
)

export default component.exports